export const ACCESS_PUBLIC = 'PUBLIC';
export const ACCESS_SITE = 'SITE';
export const ACCESS_PRIVATE = 'PRIVATE';

export const TYPE_OWN = 'OWN';
export const TYPE_ALL = 'ALL';

export const USER_ROLE_OWNER = 'OWNER';
export const USER_ROLE_VIEWER = 'READ';

export const VIDEO_ASPECT_RATIO_16X9 = 'ASPECT_RATIO_16x9';
export const VIDEO_ASPECT_RATIO_9X16 = 'ASPECT_RATIO_9x16';
export const VIDEO_ASPECT_RATIO_1X1 = 'ASPECT_RATIO_1x1';
export const VIDEO_ASPECT_RATIO_4X3 = 'ASPECT_RATIO_4x3';

export const USER_ROLE_ENUMS = [USER_ROLE_OWNER, USER_ROLE_VIEWER];

export const ACCESS_LEVEL_ENUMS = [ACCESS_PUBLIC, ACCESS_SITE, ACCESS_PRIVATE];

export const ASPECT_RATIO_ENUMS = [
  VIDEO_ASPECT_RATIO_16X9,
  VIDEO_ASPECT_RATIO_9X16,
  VIDEO_ASPECT_RATIO_1X1,
  VIDEO_ASPECT_RATIO_4X3,
];
